// graphql-ws passes the WebSocket's CloseEvent, not an Error, to `closed` and to a subscription
// that can't recover, and urql forwards the latter unchanged as `networkError`. A numeric `code`
// alone isn't enough: a DOMException carries one too.
export const getSocketCloseCode = (value: unknown): number | undefined =>
  typeof value === 'object' &&
  value !== null &&
  'code' in value &&
  typeof value.code === 'number' &&
  'reason' in value &&
  typeof value.reason === 'string'
    ? value.code
    : undefined;
